import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_ENTFERNEN = '[VorlagenModul] PostDokumentEntfernen laden';
export const POST_DOKUMENT_ENTFERNEN_AUSFUEHREN = '[VorlagenModul] PostDokumentEntfernen ausführen';
export const POST_DOKUMENT_ENTFERNEN_ERFOLGREICH = '[VorlagenModul] PostDokumentEntfernen laden erfolgreich';
export const POST_DOKUMENT_ENTFERNEN_FEHLER = '[VorlagenModul] PostDokumentEntfernen Ladefehler';
export const POST_DOKUMENT_ENTFERNEN_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostDokumentEntfernen nicht ausgeführt (evtl. Offline)';


export class PostDokumentEntfernenAction implements Action {
    readonly type = POST_DOKUMENT_ENTFERNEN;
        constructor(public dokumentEntfernenRequest: api.DokumentEntfernenRequest, public optPayload: any = null) {}
    }
export class PostDokumentEntfernenAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_ENTFERNEN_AUSFUEHREN;
        constructor(public dokumentEntfernenRequest: api.DokumentEntfernenRequest, public optPayload: any = null) {}
    }
export class PostDokumentEntfernenErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_ENTFERNEN_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentEntfernenRequest: api.DokumentEntfernenRequest, public optPayload: any = null) {}
    }
export class PostDokumentEntfernenFehlerAction implements Action {
    readonly type = POST_DOKUMENT_ENTFERNEN_FEHLER;
        constructor(public payload: any, public dokumentEntfernenRequest: api.DokumentEntfernenRequest, public optPayload: any = null) {}
    }
export class PostDokumentEntfernenNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_ENTFERNEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandDokumentEntfernenActions =
    PostDokumentEntfernenAction
    | PostDokumentEntfernenAusfuehrenAction
    | PostDokumentEntfernenErfolgreichAction
    | PostDokumentEntfernenFehlerAction
    | PostDokumentEntfernenNichtAusgefuehrtAction
    ;
